import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { CityModel } from 'src/app/shared/models/abre-cuentas.model';
import { OptionRadioModel } from 'src/app/shared/models/common.model';
import { AddressModel, ContactModel } from 'src/app/shared/models/contact.model';
import { LogDeviceModel } from 'src/app/shared/models/log-device.model';
import { IProductsModel } from 'src/app/shared/models/products.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { StringHelperService } from '../../../shared/services/helpers/string-helper.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  EVENT as EVENT_FA_TC,
  PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA,
} from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';

@Component({
  selector: 'app-address-config-tc',
  templateUrl: './address-config-tc.component.html',
  styleUrls: ['./address-config-tc.component.scss'],
})
export class AddressConfigTcComponent implements OnInit {

  formGroup: FormGroup;
  options: any;
  options2: any;
  showOptions = false;
  selectedCity: CityModel;
  addressInfo: AddressModel;
  optionConfigAddress: OptionRadioModel | any;
  homeAddress: ContactModel;
  companyAddress: any;
  devicePrint: any;
  optionsFilter: any[];
  product_type: string;
  productSelected: IProductsModel;
  addressInput: any;
  controladdress: FormControl;
  controladdressDetail: FormControl;
  pco: string;
  back = '';
  emptyAddress: AddressModel = {
    address: '',
    addressInput: '',
    city: {
      city_code: '',
      country_code: '',
      description: '',
      province_code: undefined as any,
    },
    detail: '',
  };

  /**
   * list of product types
   *
   * @type {OptionRadioModel[]}
   * @memberof PayDayFormTcComponent
   */
  listAddress: OptionRadioModel[];

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private navigationService: NavigationService,
    private stringHelperService: StringHelperService,
    private formBuilder: FormBuilder,
    private configurationService: ConfigurationService,
    private bitacoraService: BitacoraService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private taggingService: TaggingService,
    private daliService: DaliService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
    this.devicePrint = new LogDeviceModel();
    // this.listAddress = [{
    //   label: this.copyService.copies.address_config_tc_add_address,
    //   elementId: 3,
    //   checked: false,
    // }];
    this.listAddress = [];
  }

  ngOnInit() {
    this.sendTagging('init');
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendAddressConfigPageLoad();
    }
    const regexp = new RegExp(/^(?![ ])(?!.*[ ]{2})(?!.*[ ]$)[Ññ\w-#/., ]+$/);
    const selectedOccupation = this.abreCuentasService.getOccupationSelected();
    const selectedCiiu = this.abreCuentasService.getCiiuSelected();
    this.companyAddress = this.abreCuentasService.getOfficeInfo((selectedOccupation.id || '') + '');
    const additionalAddress = this.abreCuentasService.getAddressInfoConfigTc();
    this.homeAddress = this.abreCuentasService.getContactInfo();
    const productSelected = this.abreCuentasService.getproductSelected();
    const userAddressListSelection = this.abreCuentasService.getAddtionalAddressConfigTcList();
    this.addressInfo = additionalAddress === undefined ? this.emptyAddress : additionalAddress;
    this.selectedCity = this.addressInfo.city;
    this.formGroup = new FormGroup({
      'input-value-address': new FormControl(this.addressInfo.address, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(40),
        Validators.pattern(regexp),
      ]),
      'input-value-city': new FormControl(this.addressInfo.city.description, [Validators.required]),
      'input-value-addressDetail': new FormControl(this.addressInfo.detail, [
        Validators.minLength(0),
        Validators.maxLength(40),
      ]),
    });

    this.product_type = productSelected ? productSelected.product_type : '';
    this.previous();
    this.navigationService.pageLoadTag(false, ['', '', 'pv226', '']);
    if (userAddressListSelection === undefined) {
      if (this.companyAddress && this.companyAddress.address && this.companyAddress.address.address) {
        this.listAddress.unshift({
          label: `${this.companyAddress.address.address} (trabajo)`,
          elementId: 2,
          checked: false,
        });
      }
      if (this.homeAddress && this.homeAddress.address && this.homeAddress.address.address) {
        this.listAddress.unshift({
          label: `${this.homeAddress.address.address} (casa)`,
          elementId: 1,
          checked: false,
        });
      }

      if (selectedOccupation.name === 'Empleado' ||
        selectedOccupation.name === 'Independiente' && selectedCiiu.ciiu !== '090' && JSON.stringify(this.addressInfo) === '{}') {
        this.addressInfo = this.companyAddress.address || '';
      }
      if (this.companyAddress && this.companyAddress.address.address === this.addressInfo.address) {
        this.optionConfigAddress = this.listAddress.find(data => {
          data.checked = data.elementId === 2;
          return data.checked;
        });
      } else if (!this.addressInfo || !this.addressInfo.address || this.homeAddress.address.address === this.addressInfo.address) {
        this.addressInfo = this.homeAddress.address;
        this.optionConfigAddress = this.listAddress.find(data => {
          data.checked = data.elementId === 1;
          return data.checked;
        });
      } else {
        this.optionConfigAddress = this.listAddress.find(data => {
          data.checked = data.elementId === 3;
          return data.checked;
        });
      }
    } else {
      this.listAddress = userAddressListSelection;
      const addressChecked: any = { value: '' };
      addressChecked.value = this.listAddress.find(address => {
        return address.checked === true ? address : '';
      });
      this.updateSelection(addressChecked);
    }

    if ((this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC || this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING
      || this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) &&
      (this.firmlyApprovedService.isEmpty() &&
        this.firmlyApprovedService.getOfferType_Channel() !== 'En_firme')) {
      this.pco = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
    }

    this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
    this.options2 = this.options;
    this.optionsFilter = this.options.map(option => ({ data: option, value: option.description }));
  }

  /**
   * Summary Address entry change event, error validation
   *
   * @param {*} event
   * @memberof AddressConfigTcComponent
   */
  reactiveInputChangeAddress() {
    this.controladdress = this.formGroup.controls['input-value-address'] as FormControl;
    this.addressInput = this.controladdress.value;
    this.controladdress.setValue(this.controladdress.value.replace(/[^A-Za-z0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));

    this.updateAddresInfoConfigTc();
    this.abreCuentasService.setAddressInfoConfigTc(this.addressInfo);
  }

  /**
   * Summary Event for select a option for list city selected, and set value in Input
   *
   * @param {CityModel} option
   * @memberof AddressConfigTcComponent
   */
  selectOption(event: any) {
    if (event.value) {
      this.selectedCity = event.value;
      this.showOptions = true;
      this.addressInfo.city = this.selectedCity;
      this.formGroup.controls['input-value-city'].setValue(event.value.description);

      this.updateAddresInfoConfigTc();
      this.abreCuentasService.setAddressInfoConfigTc(this.addressInfo);
    } else {
      this.selectedCity = {
        city_code: '',
        country_code: '',
        province_code: 0,
        description: '',
      };
    }
  }

  /**
   * Update addressInfo variable
   *
   * @memberof updateAddresInfoConfigTc
   */
  updateAddresInfoConfigTc() {
    this.addressInfo = {
      city: this.addressInfo.city,
      addressInput: this.addressInput,
      address: this.formGroup.value['input-value-address'],
      detail: this.formGroup.value['input-value-addressDetail'] || '',
    };
  }

  /**
   * Summary event for select a option address
   *
   * @param {*} $event
   * @memberof AddressConfigTcComponent
   */
  selectRadioAddress(event) {
    event.value.checked = true;
    this.optionConfigAddress = event.value;

    if (this.addressInfo.address !== '') {
      this.updateAddressCheckedValue(event);
      this.abreCuentasService.setAddtionalAddressConfigTcList(this.listAddress);
    } else {
      this.updateSelection(event);
    }
  }

  updateAddressCheckedValue(event) {
    const copyListAddress = this.listAddress;
    copyListAddress.forEach(address => {
      if (address.elementId === event.value.elementId) {
        event.value.elementId === 1 ? this.addressInfo = this.homeAddress.address : this.addressInfo = this.companyAddress.address;
        address.checked = true;
      } else {
        address.checked = false;
      }
    });

    this.showOptions = event.value.elementId === 3 ? true : false;
    this.listAddress = copyListAddress;
  }

  /**
   * Updates address reference to selected config option
   *
   * @memberof AddressConfigTcComponent
   */
  updateSelection(event) {
    switch (event.value.elementId) {
      case 1:
        this.optionConfigAddress = event.value;
        this.addressInfo = this.homeAddress.address;
        this.showOptions = false;
        break;
      case 2:
        this.optionConfigAddress = event.value;
        this.addressInfo = this.companyAddress.address;
        this.showOptions = false;
        break;
      case 3:
        this.optionConfigAddress = event.value;
        this.showOptions = true;
        break;
      default:
        break;
    }
  }

  async nextCreditCard() {
    const type = this.optionConfigAddress.elementId;
    const bitacoraEvent = `product_addres_${type === 1 ? 'home' : type === 2 ? 'work' : 'other'}`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.configurationService.sendCardInformation();
    const body = {
      data: {
        agency: this.abreCuentasService.getAgencySelected(),
        phone: this.abreCuentasService.getContactInfo().mobile_number,
      },
    };
    this.configurationService.offersConfig(body).then(async (response: any) => {
      if (!response) { return; }
      if (response.status === 500) {
        this.navigationService.navigateToGeneralInformation('500');
        return;
      }
    }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  nextAccounts() {
    let nextStep = '200';
    if (this.pco !== undefined) {
      nextStep = this.pco === 'PCO02' ? '201' : '200';
    }
    if (this.abreCuentasService.viewOptionMultiProduct) {
      let productList = this.abreCuentasService.getProductsSelects();
      if (!this.firmlyApprovedService.isEmpty()
        && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
        && !this.abreCuentasService.getPayDayProductSelected().selectedProduct) {
        this.nextMulti();
      } else if (productList.find(find => find.product_type == BUSINESS_CONST.PRODUCT_TYPE_TC)) {
        this.configurationService.sendCardInformation();
      } else {
        this.nextMulti();
      }
    } else {
      this.navigationService.nextStep(nextStep);
    }
  }

  /**
   * Persist data and redirect to next webview
   *
   * @memberof AddressConfigTcComponent
   */
  next() {
    this.sendTagging('next', 'bottom', '2');
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    this.abreCuentasService.setAddtionalAddressConfigTcList(this.listAddress);

    if (this.showOptions) {
      this.updateAddresInfoConfigTc();
    }

    this.abreCuentasService.setAddressInfoConfigTc(this.addressInfo);

    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
      this.product_type === BUSINESS_CONST.MULTI ||
      this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN ||
      this.pco === 'PCO02') {
      this.nextAccounts();
    } else {
      this.nextCreditCard();
    }
  }

  /**
   * Summary validates forms validity
   *
   * @returns
   * @memberof AddressConfigTcComponent
   */
  isvalid() {
    let valid = false;
    if (this.showOptions) {
      valid = this.formGroup.valid;
    } else if (this.optionConfigAddress) {
      valid = true;
    } else {
      valid = false;
    }
    return valid;
  }

  /**
   * validar enviar con multi producto
   */
  nextMulti() {
    if (this.abreCuentasService.haveLoan) {
      this.navigationService.nextStep('200');
    } else {
      this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
    }
  }

  previous() {
    this.back = '';
    if (!this.abreCuentasService.viewOptionMultiProduct) {
      if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
        if (!this.navigationService.isCardDuality()) {
          this.back = '200';
        } else {
          this.back = '201';
        }
      } else {
        this.back = 'default';
      }
    } else if (this.abreCuentasService.haveLoan) {
      this.back = '202';
    }
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendAddressConfigPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv9pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv9pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv9pageFamily.path,
        value: PAGEVIEW_FA.pv9pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv9subFamily.path,
        value: PAGEVIEW_FA.pv9subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv9pageAction.path,
        value: PAGEVIEW_FA.pv9pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv9pageid.path,
        value: AddressConfigTcComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv9transactionName.path,
        value: `${PAGEVIEW_FA.pv9transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv9transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv9transactionTransactionStep.value,
      },
    ];
    this.taggingService.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */

  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'bottom', '1');
    if (!this.taggingService.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_TC.pv9E1setData.pv9E1transactionTransactionStep.path,
        value: EVENT_FA_TC.pv9E1setData.pv9E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv9E1setData.pv9E1transactionName.path,
        value: `${EVENT_FA_TC.pv9E1setData.pv9E1transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.center,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv9E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_TC.pv9E2setData.pv9E2transactionTransactionStep.path,
        value: EVENT_FA_TC.pv9E2setData.pv9E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_TC.pv9E2setData.pv9E2transactionName.path,
        value: `${EVENT_FA_TC.pv9E2setData.pv9E2transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_TC.customCategory.module.body,
        type: EVENT_FA_TC.customCategory.type.button,
        position: EVENT_FA_TC.customCategory.position.center,
      },
      action: EVENT_FA_TC.customAction.click,
      label: EVENT_FA_TC.pv9E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '17';
    const extras = {
      pageValue: 'AddressConfigTc',
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }
}
